 $(document).ready(function () {

           $('body').on('click', '.header__inline-menu li, .custom__btn, .footer-block__details-content li', function () {
            var clicked_val = $(this).attr('data-name');
            $('html, body').animate({
                    scrollTop: $('#' + clicked_val).offset().top - 100
                }, 2000);
         
           $('.header__inline-menu li').removeClass('active_menu');
           $(this).addClass('active_menu');
         });

   
           $('body').on('click', '.menu-drawer__menu li', function () {
            $('header-drawer summary.header__icon.header__icon--menu').trigger('click');
              //$('header-drawer summary.header__icon.header__icon--menu').click();
            var clicked_val = $(this).attr('data-name');
            $('html, body').animate({
                    scrollTop: $('#' + clicked_val).offset().top - 100
                }, 2000);
         
           $('.header__inline-menu li').removeClass('active_menu');
           $(this).addClass('active_menu');
         });

   
            // Handle the toggle when the FAQ item is clicked (either heading or text block)
            $('.text').click(function (e) {
                // Prevent event from firing multiple times (if child elements are clicked)
                if (!$(e.target).closest('.toggle-answer').length) {
                    e.preventDefault();
                }

                var parentText = $(this);

                // Close all other answers except the clicked one
                $('.text').not(parentText).removeClass('active').find('.answer').slideUp();
                $('.text').not(parentText).find('.toggle-answer svg').removeClass('open');

                // Slide toggle the clicked answer (show or hide the answer)
                parentText.find('.answer').stop(true, true).slideToggle();

                // Toggle the 'active' class to change background and show the answer
                parentText.toggleClass('active');

                // Toggle the 'open' class on the SVG icon for rotation
                parentText.find('.toggle-answer svg').toggleClass('open');
            });





/* table section */


        // Highlight the third column (column 3) by default
            $('#myTable td:nth-child(3), #myTable th:nth-child(3)').addClass('active-column');
 
            // Add click event listener for table cells
            $('#myTable').on('click', 'td, th', function () {
                var $cell = $(this); // Get the clicked cell
                var columnIndex = $cell.index() + 1; // Get 1-based column index
 
                if (columnIndex < 3 || columnIndex > 5) return; // Allow only columns 3, 4, and 5
 
                // Remove 'active-column' class from all cells
                $('#myTable td, #myTable th').removeClass('active-column');
 
                // Add 'active-column' class to all cells in the clicked column
                $('#myTable td:nth-child(' + columnIndex + '), #myTable th:nth-child(' + columnIndex + ')').addClass('active-column');
            });




$(window).on( "scroll", function() {
   if($('.section-header').hasClass('shopify-section-header-sticky')){
     $('body').addClass('top_padding');
   }else{
       $('body').removeClass('top_padding');
   }
 });
   
 });
